import { i18n } from '@lingui/core';

export type PourApprovalPageParams = Readonly<Record<'accessToken' | 'projectId' | 'pourId', string | undefined>>;

export const ACCESS_TOKEN_IDENTIFIER = ':accessToken';
export const PROJECT_IDENTIFIER = ':projectId';
export const POUR_IDENTIFIER = ':pourId';

// https://localhost:5001/app/public/project/qwerqwerqwer/pour/qwerqwerqwerqwer/token/asdfasdfasdfasdfasdfasdf
export const ROUTE_PATH = `/public/project/${PROJECT_IDENTIFIER}/pour/${POUR_IDENTIFIER}/token/${ACCESS_TOKEN_IDENTIFIER}`;
export const TITLE = i18n._('Approve Pour');
